module.exports = __webpack_public_path__ + "img/jujubottleshop.cd5d7ea7.png";